import React, {useState} from "react";
import Swal from "sweetalert2";
import {useNavigate} from "react-router-dom"
import { Link } from "react-router-dom";
import Grid from '@mui/joy/Grid';
import Input from '@mui/joy/Input';
import FormControl from '@mui/joy/FormControl';
import FormLabel from '@mui/joy/FormLabel';
import AuthService from "../../services/authService";

function ForcePassword() {
  
  const initModel = {
    password_old: '',
    password: '',
    password_confirmation: '',
  }
  const navigate = useNavigate();
  const [sending, setSending] = useState(false)
  const [formModel, setFormModel] = useState(initModel);
  const userProfile = JSON.parse(sessionStorage.getItem("tempToken"));

  const doSummit = async (event) => {
    event.preventDefault(); 
    setSending(true);
    if(validateForm()){
      if(userProfile.token !== undefined && userProfile.token !== null && userProfile.token !== ''){
        AuthService.setFirstPassword(formModel)
          .then((response) => { sessionStorage.removeItem("tempToken"); })
          .catch((error) => {
            if(error.response.status !== 401){
                Swal.fire({
                    title: 'Ooops?',
                    text: error.response.data.errors[0].detail,
                    icon: 'error',
                    confirmButtonText: 'OK',
                    confirmButtonColor: '#f13939'
                })
            }else{
              sessionStorage.removeItem("tempToken");
              navigate('/')
              window.location.reload();
            }
          })
          .finally(() => { navigate("/") })
      }else{
        Swal.fire({
          title: 'Ooops?',
          text: 'Hay un error!',
          icon: 'error',
          confirmButtonText: 'OK',
          confirmButtonColor: '#f13939'
        })
      }
    }else{
      Swal.fire({
        title: 'Ooops?',
        text: 'Debe completar los datos para poder avanzar!',
        icon: 'error',
        confirmButtonText: 'OK',
        confirmButtonColor: '#f13939'
      })
    }
    setSending(false);
  }

  const validateForm = function(){
    let rta = true;
    if(formModel.password_old === '' || formModel.password_old === undefined  || formModel.password_old === null){ return false; } 
    if(formModel.password === '' || formModel.password === undefined  || formModel.password === null){ return false; } 
    if(formModel.password_confirmation === '' || formModel.password_confirmation === undefined  || formModel.password_confirmation === null){ return false; } 
    if(formModel.password_confirmation !== formModel.password){ return false; }    
    return rta;
  }
   
    return (
        <div>
          <div className="container-xxl">
            <div className="authentication-wrapper authentication-basic container-p-y">
              <div className="authentication-inner">
                {/* New Password */}
                <div className="card">
                  <div className="card-body">
                    {/* Logo */}
                    <div className="app-brand justify-content-center">
                      <a href="/" className="app-brand-link gap-2">
                        <img src="alchemy-logo.png" alt="alchemy valores logo" className="img-fluid" style={{width: '100%'}}/>
                      </a>
                    </div>
                    {/* /Logo */}
                    <h4 className="mb-2">Nueva clave 🔒</h4>
                    <p className="mb-4">Ingresa tu nueva clave para acceder a la aplicación.</p>
                    <form onSubmit={doSummit}>
                        <Grid container spacing={2} sx={{ flexGrow: 1 }} className={'mb-4'}>
                          <Grid xs={12}>
                            <FormControl>
                                <FormLabel className="form-labels">Contraseña actual</FormLabel>
                                <Input type="password" size="md" placeholder="Ingrese contraseña actual" autoFocus onChange={(e)=> setFormModel({...formModel, password_old: e.target.value})}/>
                            </FormControl>
                          </Grid>
                          <Grid xs={12}>
                            <FormControl>
                                <FormLabel className="form-labels">Nueva contraseña</FormLabel>
                                <Input type="password" size="md" placeholder="Ingrese nueva contraseña" onChange={(e)=> setFormModel({...formModel, password: e.target.value})}/>
                            </FormControl>
                          </Grid>
                          <Grid xs={12}>
                            <FormControl>
                                <FormLabel className="form-labels">Repetir nueva contraseña</FormLabel>
                                <Input type="password" size="md" placeholder="Repetir la nueva contraseña" onChange={(e)=> setFormModel({...formModel, password_confirmation: e.target.value})}/>
                            </FormControl>
                          </Grid>
                        </Grid>
                        <div className="mb-3">
                        { sending ? 
                          <div className="d-flex justify-content-center">
                            <div className="spinner-border text-info" role="status">
                              <span className="visually-hidden">Loading...</span>
                            </div>
                          </div>
                        : 
                          <button className="btn btn-info d-grid w-100" type="submit" onClick={doSummit}>Crear nueva contraseña</button> 
                        } 
                        </div>
                    </form>
                      <div className="text-center">
                        <Link to='/' className="d-flex align-items-center justify-content-center">
                            <i className="bx bx-chevron-left scaleX-n1-rtl bx-sm" />
                            Volver
                        </Link>
                    </div>

                  </div>
                </div>
                {/* /Register */}
              </div>
            </div>
          </div>
          <footer style={{textAlign: 'right', marginRight: 20,fontSize: 'small', marginTop: '-25px'}}>
            Power by <a href="https://globemind.com/" target="_blank" style={{color: '#396bad'}} rel="noreferrer">GlobeMind</a>
          </footer>
        </div>        
  
      );
}

  
export default ForcePassword;